import { createContext } from "react";

interface VariantContextProps {
    isInfoMode?: boolean;
    moduleId?: string;
}

export const VariantContext = createContext<VariantContextProps>({
    isInfoMode: false,
});
